import React, { useState } from 'react';

const ImageUploader = ({ onImageUpload }) => {
    const [isDragging, setIsDragging] = useState(false);

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            onImageUpload(file);
        }
    };

    const handleDragOver = (event) => {
        event.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = () => {
        setIsDragging(false);
    };

    const handleDrop = (event) => {
        event.preventDefault();
        setIsDragging(false);
        const file = event.dataTransfer.files[0];
        if (file) {
            onImageUpload(file);
        }
    };

    const handleClick = () => {
        document.getElementById('image-upload').click(); // Trigger the hidden input click
    };

    return (
        <div
            className={`image-uploader ${isDragging ? 'dragging' : ''}`}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            onClick={handleClick} // Make the entire box clickable
        >
            <label htmlFor="image-upload" className="image-section-box">
                {isDragging
                    ? 'Drop the image here'
                    : 'Click here or drag and drop an image to upload'}
            </label>
            <input
                type="file"
                id="image-upload"
                accept="image/*"
                onChange={handleImageChange}
                style={{ display: 'none' }} // Hide the input element
            />
        </div>
    );
};

export default ImageUploader;